import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OktaAuth } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import {variables} from '../Variables.js';

// Okta Configuration
const OKTA_ISSUER = 'https://auth.eutelsat.net';
const CLIENT_ID = '0oatve584stItlPRC417';
// My Okta
// const OKTA_ISSUER = 'https://trial-6732986.okta.com';
// const CLIENT_ID = '0oazqywfkhloDmQ9c697';

// Use the same redirect URI as LoginOkta.jsx (must match Okta app configuration)
const REDIRECT_URI = window.location.origin;
const API_BASE_URL = variables.API_URL || 'http://127.0.0.1:8000';

const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  responseType: 'code',
  tokenManager: {
    autoRenew: true,
  }
});

export const handleLogout = async () => {
  try {
    await oktaAuth.signOut();
  } catch (err) {
    console.error('[Logout] Error:', err);
  } finally {
    localStorage.clear();
    window.location.replace(window.location.origin + "/#/login/");
  }
};

function LoginComponent() {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // OAuth callback is now handled by OktaLoginCallback + handleLoginRedirect in App.js

  // Redirect if already authenticated
  useEffect(() => {
    console.log('[AuthState] AuthState:', authState);
    if (authState?.isAuthenticated) {
      // navigate('/dashboard');
    }
  }, [authState?.isAuthenticated, navigate]);

  const handleLogin = async () => {
    console.log('[Login] Initiating login redirect...');
    setLoading(true);
    setError(null);
    try {
      await oktaAuth.signInWithRedirect();
    } catch (err) {
      console.error('[Login] Error:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  // Show loading during initialization or callback processing
  if (!authState || loading) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <div className="content text-center px-4">
              <h1 className="text-primary">Welcome to Purchase Plan Tool v.1.0</h1>
              <p className="content">Login now and start enjoying!<br /></p>
            </div>
          </div>
          <div className="col-md-6 p-5">
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">
                {loading ? 'Redirecting...' : 'Initializing...'}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6 d-flex align-items-center">
          <div className="content text-center px-4">
            <h1 className="text-primary">Welcome to Purchase Plan Tool v.1.0</h1>
            <p className="content">Login now and start enjoying!<br /></p>
          </div>
        </div>
        <div className="col-md-6 p-5">
          <div className="border p-4 rounded">
            {error && (
              <div className="alert alert-danger mb-3">
                <strong>Error:</strong> {error}
                <button 
                  className="btn btn-sm btn-link"
                  onClick={() => {
                    setError(null);
                    window.location.reload();
                  }}
                >
                  Retry
                </button>
              </div>
            )}
            
            <button 
              className="btn btn-primary w-100" 
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? 'Redirecting...' : 'Login with your Eutelsat account'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Export LoginComponent for use in routes (Security provider is now in index.js)
function Login() {
  return <LoginComponent />;
}

// Export oktaAuth instance so it can be used in other components
export { oktaAuth };
export default Login;
